import { authenticatedApi } from './api';

export const API_CONVERSATION_PATH = '/conversation';

export const fetchConversations = (lastTimestamp, tab = 'all') => authenticatedApi.get(
	API_CONVERSATION_PATH,
	{ params: { lastTimestamp, tab } },
);

export const createConversation = ({ users, name, groupId, target }) => authenticatedApi.post(
	API_CONVERSATION_PATH,
	{ users, name, groupId, target },
);

export const deleteConversation = (conversationId) => authenticatedApi.delete(
	`${API_CONVERSATION_PATH}/${conversationId}`,
);

export const hideConversation = (conversationId) => authenticatedApi.delete(
	`${API_CONVERSATION_PATH}/${conversationId}/hide`,
);

export const fetchConversationMessages = (conversationId, lastTimestamp) => authenticatedApi.get(
	`${API_CONVERSATION_PATH}/${conversationId}/messages`,
	{ params: { lastTimestamp } },
);

export const sendMessage = ({
	conversationId, text, images, videos }) => authenticatedApi.post(
	`${API_CONVERSATION_PATH}/${conversationId}/messages`,
	{ text, images, videos },
);

export const updateMessage = ({
	conversationId, messageId, text, images, videos }) => authenticatedApi.put(
	`${API_CONVERSATION_PATH}/${conversationId}/messages/${messageId}`,
	{ text, images, videos },
);

export const sendMessageToManyUsers = ({
	text, images, videos, target }) => authenticatedApi.post(
	`${API_CONVERSATION_PATH}/messages/followers`,
	{ text, images, videos, target },
);

export const deleteMessage = ({ conversationId, messageId }) => authenticatedApi.delete(
	`${API_CONVERSATION_PATH}/${conversationId}/messages/${messageId}`,
);

export const markConversationAsRead = (conversationId) => authenticatedApi.put(
	`${API_CONVERSATION_PATH}/${conversationId}/mark_as_read`,
);
